import { PlusIcon } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { useRegisterApplicantDialog } from '../../dialogs/hooks/use-register-applicant-dialog'

export const AddApplicantButton: React.FC = () => {
  const { openDialog: openRegisterApplicantDialog } = useRegisterApplicantDialog()

  return (
    <Button size="sm" className={cn('w-fit')} onClick={openRegisterApplicantDialog}>
      <PlusIcon size={16} />
      <span className="pl-2">Add Applicant</span>
    </Button>
  )
}
